import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

import globals from '@/globals'

import Center from './Center'
import Assist from './Assist'
// System
import SystemBase from './System/Base'
import SystemLog from './System/Log'
// Business
import BusinessStudy from './Business/Study'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  // Default route
  // { path: '', redirect: '/Search/SearchSaleRankQ' }
  { path: '', redirect: '/Center/Version' }
]
  .concat(Center)
  .concat(Assist)
  // System
  .concat(SystemBase)
  .concat(SystemLog)
  // Business
  .concat(BusinessStudy)

// 404 Not Found page
ROUTES.push({
  path: '*',
  component: NotFound
})

const router = new Router({
  // base: '/',
  base: process.env.BASE_URL,
  mode: 'hash',
  // mode: 'history',
  routes: ROUTES
})

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(() =>
      splashScreen && splashScreen.parentNode && splashScreen.parentNode.removeChild(splashScreen)
    , 300)
  }

  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  // document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
